import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { AppFrame, TopBar, BottomNav, WhatsAppFAB } from "@/components/Shell";

export default function CategoryPage() {
  const { id } = useParams();
  const [category, setCategory] = useState(null);
  const [subs, setSubs] = useState([]);
  const [products, setProducts] = useState([]);
  const [activeSub, setActiveSub] = useState(null);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    (async () => {
      const s = await api.get("/settings"); setSettings(s.data);
      const c = await api.get("/categories");
      const cur = c.data.find((x) => x.id === id);
      setCategory(cur);
      const children = c.data.filter((x) => x.parent_id === id);
      setSubs(children);
      setActiveSub(null);
      const p = await api.get("/products", { params: { category_id: id, limit: 100 } });
      setProducts(p.data);
    })();
  }, [id]);

  useEffect(() => {
    (async () => {
      if (!category) return;
      const p = await api.get("/products", {
        params: activeSub ? { category_id: activeSub } : { category_id: id, limit: 100 },
      });
      setProducts(p.data);
    })();
  }, [activeSub]); // eslint-disable-line

  return (
    <AppFrame>
      <TopBar title={category?.name || "Category"} subtitle="Collection" />
      {subs.length > 0 && (
        <div className="px-5 mt-4">
          <div className="flex gap-2 overflow-x-auto no-scrollbar -mx-5 px-5 pb-1">
            <button
              data-testid="sub-all-btn"
              onClick={() => setActiveSub(null)}
              className={`shrink-0 rounded-full px-4 py-2 text-xs press border ${!activeSub ? "bg-neutral-900 text-white border-neutral-900" : "border-black/10 text-neutral-700"}`}
            >
              All
            </button>
            {subs.map((s) => (
              <button
                key={s.id}
                data-testid={`sub-cat-${s.id}`}
                onClick={() => setActiveSub(s.id)}
                className={`shrink-0 rounded-full px-4 py-2 text-xs press border ${activeSub === s.id ? "bg-neutral-900 text-white border-neutral-900" : "border-black/10 text-neutral-700"}`}
              >
                {s.name}
              </button>
            ))}
          </div>
        </div>
      )}

      <div className="px-5 mt-6">
        {products.length === 0 ? (
          <div className="rounded-2xl bg-zinc-50 border border-black/5 py-14 text-center">
            <div className="font-display text-lg">Nothing here yet</div>
            <p className="text-xs text-neutral-500 mt-1">New arrivals coming soon.</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>

      <WhatsAppFAB number={settings?.whatsapp_number} />
      <BottomNav />
    </AppFrame>
  );
}
